// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".edit-page-box .van-cell::after {\n  border: none;\n}\n.edit-page-box .van-field {\n  background: rgba(255, 255, 255, 0.3);\n}\n.edit-page-box .van-field__body {\n  height: 2.4rem !important;\n}\n.edit-page-box .van-field__body .van-field__control {\n  height: 100% !important;\n}\n.edit-page-box .van-field__body .van-field__control::-webkit-input-placeholder {\n  font-size: 0.37333rem;\n  color: rgba(3, 3, 3, 0.65);\n}\n", ""]);
// Exports
module.exports = exports;
